import React, { useContext, useState } from "react";
import { toFarsiNumber } from "../../helper/helper";
import { getItemStorage } from "../../Localstorage/useLocalStorage";
import { UserData } from "../../contexts/UserInfoContext";
import { Link } from "react-router-dom";

const EpisodePageAccordion = ({ data, active, buy, lessonData }) => {
  const [open, setOpen] = useState(false);
  const { user } = useContext(UserData);
  const token = getItemStorage("token");
  const episodeDataHandler = (ep) => {};

  return (
    <div
      className={`w-full flex flex-col ${
        open ? "max-h-[1000px] h-fit" : "max-h-12"
      } rounded-xl transition-all duration-300  overflow-hidden`}
    >
      {/* open & close accordion */}
      <button
        onClick={() => setOpen(!open)}
        className={`w-full min-h-12 ${
          open ? "bg-gray-800 bg-opacity-70 h-fit" : "bg-gray-800"
        } hover:bg-opacity-70 transition-all duration-300 flex justify-between items-center cursor-pointer p-4`}
      >
        <h3
          className={`text-gray-200 text-right font-semibold ${
            open ? "" : "line-clamp-1"
          }`}
        >
          {data.name}
        </h3>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class={`w-5 h-5 stroke-gray-200 ${
            open && "rotate-180"
          } transition-all duration-300`}
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m19.5 8.25-7.5 7.5-7.5-7.5"
          />
        </svg>
      </button>

      <div className="bg-gray-800 overflow-y-auto table-scroll flex flex-col gap-4 p-4">
        {/* seasen episodes */}
        {data.episodes.length > 0 ? (
          data.episodes.map(
            (ep, index) =>
              ep.video && (
                <Link
                  to={`/ep/${ep.id}`}
                  onClick={() => episodeDataHandler(ep)}
                  className="cursor-pointer flex flex-col gap-5 pb-4 group border-b border-gray-700 last:border-b-0"
                >
                  <div className="flex items-center gap-3">
                    <div
                      className={`min-w-7 h-7 group-hover:bg-yellow-700 text-gray-200 ${
                        ep.id == active ? "bg-yellow-700" : "bg-gray-700"
                      } flex items-center justify-center transition-all duration-300 rounded-lg`}
                    >
                      {toFarsiNumber(index + 1)}
                    </div>
                    <h4
                      className={`${
                        ep.id == active ? "text-yellow-700" : "text-gray-200"
                      }  group-hover:text-yellow-700 text-sm transition-all duration-300`}
                    >
                      {ep.name}
                    </h4>
                  </div>

                  <div className="flex items-center justify-between">
                    <span
                      className={`text-[13px] block ${
                        ep.id == active
                          ? "bg-green-800 text-green-600"
                          : buy === false ||
                            user?.user?.developer === 1 ||
                            lessonData?.ranks?.filter(
                              (item) =>
                                item.rank >= user?.user?.level ||
                                item.rank === 100
                            ).length ||
                            (buy && ep.lock === 0)
                          ? "text-yellow-700 group-hover:bg-yellow-700 bg-yellow-800 group-hover:text-gray-200 "
                          : buy === true &&
                            ep.lock === 1 &&
                            "text-red-600 group-hover:bg-red-600 bg-red-700 group-hover:text-gray-200 "
                      } transition-all duration-300 bg-opacity-30 py-1 px-2 rounded-md`}
                    >
                      {/* {ep.lock === 1 ? "وارد حساب شوید" : "مشاهده"} */}
                      {ep.id == active
                        ? "درحال مشاهده"
                        : buy === false ||
                          user?.user?.developer === 1 ||
                          lessonData?.ranks?.filter(
                            (item) =>
                              item.rank >= user?.user?.level ||
                              item.rank === 100
                          ).length ||
                          (buy === true && ep.lock === 0)
                        ? "مشاهده"
                        : buy === true &&
                          ep.lock === 1 &&
                          "دوره را خریداری کنید"}
                    </span>

                    <div className="flex items-center flex-row-reverse gap-2">
                      {buy === false ||
                      user?.user?.developer === 1 ||
                      lessonData?.ranks?.filter(
                        (item) =>
                          item.rank >= user?.user?.level || item.rank === 100
                      ).length ||
                      (buy === true && ep.lock === 0) ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-6 h-6 stroke-gray-400 group-hover:stroke-yellow-700 transition-all duration-300"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                          />
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-6 h-6 stroke-gray-400 group-hover:stroke-red-600 transition-all duration-300"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
              )
          )
        ) : (
          <span className="text-gray-300">
            فعلا ویدیو ای برای این فصل قرار نگرفته است!
          </span>
        )}
      </div>
    </div>
  );
};

export default EpisodePageAccordion;
